import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardLoadingButton, StandardLoadingButtonProps } from "../buttons/LoadingButton"

const useStyles = makeStyles()((theme) => ({
    button: {
        width: "fit-content",
        minHeight: "2.5rem",
        background: theme.palette.common.white,
    },
}))

type StandardExportButtonProps = Pick<StandardLoadingButtonProps, "endIcon" | "onClick"> &
    Readonly<{
        loading?: StandardLoadingButtonProps["loading"]
        disabled?: boolean
        className?: string
    }>

export function StandardExportButton({
    loading = false,
    endIcon,
    onClick,
    disabled = false,
    className,
}: StandardExportButtonProps) {
    const { classes, cx } = useStyles()

    return (
        <LocalizedStrict id="export-button-export-text">
            <StandardLoadingButton
                variant="outlined"
                size="small"
                endIcon={endIcon}
                loading={loading}
                onClick={onClick}
                className={cx(classes.button, className)}
                disabled={disabled}
            >
                Export
            </StandardLoadingButton>
        </LocalizedStrict>
    )
}
